import { useMutation, useQueryClient } from "@tanstack/react-query";
import { reclassify } from "@services/subscriberSyncUpload";

export function useReclassifySubscriberSync(options: any = {}) {
  const queryClient = useQueryClient();

  return useMutation(reclassify, {
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["subscriberSyncUploads"] });
      queryClient.invalidateQueries({
        queryKey: ["subscriberSyncUpload", variables.uploadId],
      });
    },
    ...options,
  });
}
